import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { GridConstants } from '../../constants/Grid';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDefaultArtByType, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { isRetired } from '../../lib/RightsUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import PodcastProgramMetadata from '../PodcastProgramMetadata/PodcastProgramMetadata';

import CatalogGridItem from './CatalogGridItem';

/*
 * PodcastProgramGridItem is for rendering T3 podcast program grid items.
 *
 * See CatalogGridItem and lib/GridItem for additional available props.
 */
class PodcastProgramGridItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    secondText: PropTypes.string,
    episodeCount: PropTypes.number,
    collectedEpisodeCount: PropTypes.number,
    showNewBadge: PropTypes.bool,
    showSourceName: PropTypes.bool,
    isRetired: PropTypes.bool,
  };

  render() {
    const { episodeCount, collectedEpisodeCount, showNewBadge, showSourceName, ...gridItemProps } =
      this.props;

    return (
      <CatalogGridItem
        thirdText={
          <PodcastProgramMetadata
            episodeCount={episodeCount}
            collectedEpisodeCount={collectedEpisodeCount}
            showSourceName={showSourceName}
            showNewBadge={showNewBadge}
          />
        }
        {...gridItemProps}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const { id, isMixedWithOtherSources } = ownProps;
  const details = getAnnotationsById(state, id);

  props.blankItem = !details;
  props.defaultPlaceholderArt = !details
    ? getDefaultArtByType(PandoraTypes.EPISODE, GridConstants.GRID_ITEM_IMAGE_SIZE)
    : null;

  if (details && id) {
    const backstageUrl = details.get('shareableUrlPath');
    props.mainText = details.get('name');
    props.mainTextUrl = backstageUrl;
    props.itemOnclickUrl = backstageUrl;
    props.secondText = details.get('publisherName');
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state, PandoraTypes.PODCAST);
    props.dominantColor = getDominantColor(details);
    props.isPlayingCurrently = getInDomain('playback.utils.isSourcePlayingCurrently', false)(
      state,
      id,
    );
    props.isPaused =
      !getInDomain('playback.utils.isAudioPlaying')(state) && props.isPlayingCurrently;
    props.episodeCount = details.get('episodeCount');
    props.showNewBadge = getInDomain('playback.utils.shouldPodcastShowNewBadge', null)(state, id);
    props.showSourceName = isMixedWithOtherSources;
    props.isRetired = isRetired(details);
    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: id,
      pandoraType: PandoraTypes.PODCAST,
      shareParentSource: {
        shareParentSourceId: id,
        shareParentSourceType: PandoraTypes.PODCAST,
      },
    });
  }
  return props;
}

export default connect(mapStateToProps)(PodcastProgramGridItem);
